import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type LabelValue from 'commons/modules/label-value';

import type { ChipDataType, ClientsStoreType } from './types/clients-store';
import type { RootState } from './configureStore';

const initialState: ClientsStoreType = {
  selectedClient: null,
  selectedClientAccount: null,
  valueSearch: null,
  optionFilter: null,
  chipData: [],
};

export const slice = createSlice({
  name: 'clients',
  initialState: { ...initialState },
  reducers: {
    setSelectedClient: (
      balance: ClientsStoreType,
      action: PayloadAction<any>,
    ) => {
      balance.selectedClient = action.payload;
    },
    setSelectedClientAccount: (
      balance: ClientsStoreType,
      action: PayloadAction<any>,
    ) => {
      balance.selectedClientAccount = action.payload;
    },
    setValueSearch: (
      balance: ClientsStoreType,
      action: PayloadAction<string | null>,
    ) => {
      balance.valueSearch = action.payload;
    },
    setOptionFilter: (
      balance: ClientsStoreType,
      action: PayloadAction<LabelValue | null>,
    ) => {
      balance.optionFilter = action.payload;
    },
    setChipData: (
      balance: ClientsStoreType,
      action: PayloadAction<ChipDataType[]>,
    ) => {
      balance.chipData = action.payload;
    },
    cleanData: () => initialState,
  },
});

export const {
  setSelectedClient,
  setSelectedClientAccount,
  setValueSearch,
  setOptionFilter,
  setChipData,
  cleanData,
} = slice.actions;
export default slice.reducer;

// Selectors
export const getSelectedClient = (state: RootState) =>
  state.entities.clients.selectedClient;
export const getSelectedClientAccount = (state: RootState) =>
  state.entities.clients.selectedClientAccount;
export const getValueSearch = (state: RootState) =>
  state.entities.clients.valueSearch;
export const getOptionFilter = (state: RootState) =>
  state.entities.clients.optionFilter;
export const getChipData = (state: RootState) =>
  state.entities.clients.chipData;
